import { render, staticRenderFns } from "./ed-assign-main-placeholder.component.vue?vue&type=template&id=13fd18dc&scoped=true&"
import script from "./ed-assign-main-placeholder.component.ts?vue&type=script&lang=ts&"
export * from "./ed-assign-main-placeholder.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-assign-main-placeholder.component.scss?vue&type=style&index=0&id=13fd18dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd18dc",
  null
  
)

export default component.exports